import React from 'react';
import { Link } from 'react-router-dom';
import why_work from '../../../assets/images/why-work.png';
import { Navigate } from 'react-router-dom';
import CustomModalView from '../../../common/input/customModal/customModalView';

const ClientFormView = (props) => {
  // if (localStorage.getItem("token") != null) {
  return (
    <>
      <div className="registration-form_main">
        <div className="registration-form_wrapper">
          <form id="individual-personal-details_form">
            <div className="form-group">
              <label>
                Company Number<sup>*</sup>
              </label>
              <div className="row">
                <div className=" col-sm-9 mb-10">
                  <input
                    value={props.company_number}
                    onChange={(e) =>
                      props.handelData('company_number', e.target.value)
                    }
                    type="text"
                    className="form-control"
                    placeholder="WC2N 5DU"
                  />
                </div>
                <button
                  type="button"
                  onClick={() => props.fetch_company_details()}
                  className="btn btn-primary btn-sm mt-n3 col-sm-3"
                >
                  search
                </button>
              </div>
              {/* <div className="form-error-msg">{props.setzipcode_validate}</div> */}
            </div>
            <div className="form-group">
              <label>
                Company Name<sup>*</sup>
              </label>
              <div className="form-row">
                <div className="col">
                  <input
                    value={props.company_name}
                    onChange={(e) =>
                      props.handelData('company_name', e.target.value)
                    }
                    type="text"
                    className="form-control"
                  />
                </div>
              </div>
              {/* <div className="form-error-msg">{props.setzipcode_validate}</div> */}
            </div>

            <div className="form-group">
              <label>
                Legal Entity<sup>*</sup>
              </label>
              <select
                value={props.legal_entity}
                class="form-control"
                onChange={(e) =>
                  props.handelData('legal_entity', e.target.value)
                }
                id="exampleFormControlSelect1"
              >
                <option>Pick the Legal Entity</option>
                <option value="PL">Private Limited</option>
                <option value="LLP">LLP (Limited Liability Partnership)</option>
                <option value="ST">ST(Sole Trader)</option>
                <option value="PT">Partnership</option>
              </select>
            </div>
            <div className="form-group">
              <label>
                Registered office<sup>*</sup>
              </label>
              <input
                type="text"
                value={props.registered_office}
                onChange={(e) =>
                  props.handelData('registered_office', e.target.value)
                }
                className="form-control"
                placeholder="Your Address here"
              />
              {/* <div className="form-error-msg">{props.setaddress_validate}</div> */}
            </div>
            <div className="form-group">
              <label>
                Enter Your Post Code,Select Search Buttons<sup>*</sup>
              </label>
              <div className="row">
                <div className=" col-sm-9 mb-10">
                  <input
                    type="text"
                    value={props.postal_code}
                    onChange={(e) =>
                      props.handelData('postal_code', e.target.value)
                    }
                    className="form-control"
                    placeholder="Your PostCode here"
                  />
                </div>
                <button
                  type="button"
                  onClick={() => props.getDataPostCode()}
                  className="btn btn-primary btn-sm mt-n3 col-sm-3"
                >
                  search
                </button>
              </div>
            </div>

            <div className="form-group">
              <label>
                Select Address From the List After Entering Post Code
                <sup>*</sup>
              </label>
              {/* <input type="text" value={props.trading_address} onChange={(e) => props.handelData('trading_address', e.target.value)} className="form-control" placeholder="Your Address here" /> */}
              {/* <div className="form-error-msg">{props.setaddress_validate}</div> */}

              <select
                value={props.trading_address}
                class="form-control"
                onChange={(e) =>
                  props.handelData('trading_address', e.target.value)
                }
                id="exampleFormControlSelect1"
              >
                {props.addresses.length === 0 ? (
                  <option>Enter the PostCode</option>
                ) : (
                  <option>Select The Address</option>
                )}
                {!props.addresses.length && props.trading_address && (
                  <option selected>{props.trading_address}</option>
                )}
                {props.addresses &&
                  props.addresses.map((address) => (
                    <option value={address}>
                      {address.replace(', , ,', '')}
                    </option>
                  ))}
              </select>
            </div>
            <dv></dv>
            <div className="form-group">
              <label>
                Communication Address<sup>*</sup>
              </label>
              <select
                value={props.communication_address}
                class="form-control"
                onChange={(e) =>
                  props.handelData('communication_address', e.target.value)
                }
                id="exampleFormControlSelect1"
              >
                <option>Pick the Communication Address</option>
                <option value="Registered office">Registered office</option>
                <option value="Trading office">Trading office</option>
              </select>
            </div>

            <div className="form-group">
              <label>
                Phone Number<sup>*</sup>
              </label>
              <input
                type="text"
                value={props.phone}
                onChange={(e) => props.handelData('phone', e.target.value)}
                className="form-control"
                placeholder="Your Phone Number here"
              />
              {/* <div className="form-error-msg">{props.setaddress_validate}</div> */}
            </div>
            <div className="form-group">
              <label>Fax</label>
              <input
                type="text"
                value={props.fax}
                onChange={(e) => props.handelData('fax', e.target.value)}
                className="form-control"
                placeholder="Fax"
              />
              {/* <div className="form-error-msg">{props.setaddress_validate}</div> */}
            </div>
            <div className="form-group">
              <label>
                Email<sup>*</sup>
              </label>
              <input
                type="email"
                value={props.email}
                onChange={(e) => props.handelData('email', e.target.value)}
                className="form-control"
                placeholder="Your Email here"
              />
              {/* <div className="form-error-msg">{props.setaddress_validate}</div> */}
            </div>

            {props.edit_button ? (
              <div className="form-btn_group">
                <button
                  onClick={props.handelSubmit}
                  type="button"
                  className="btn btn-red test"
                >
                  Update{' '}
                  <i
                    className="fa fa-angle-double-right"
                    aria-hidden="true"
                  ></i>
                </button>
              </div>
            ) : (
              <div className="form-btn_group">
                <button
                  onClick={props.handelSubmit}
                  type="button"
                  className="btn btn-red test"
                >
                  Submit{' '}
                  <i
                    className="fa fa-angle-double-right"
                    aria-hidden="true"
                  ></i>
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
      <CustomModalView
        modal_show={props.modal_show}
        authResponse={props.authResponse}
        showCustomModal={props.showCustomModal}
        hideCustomModal={props.hideCustomModal}
        custom_model={props.custom_model}
      />
    </>
  );
  // }else{
  //     return (
  //       <Navigate to="/login" />
  //     )
  // }
};

export default ClientFormView;
